import React from 'react'
import AppContext from 'AppContext'
import { env } from 'components/Helpers'

const Comments = (props) => {
  const token = window.localStorage.getItem('auth-token')
  const { operator: { id: operatorId } } = React.useContext(AppContext)
  const { member: { id: membershipId } } = props

  // We may have to wait for AppContext to be available
  if (!operatorId) {
    return (
      <div className='index sales-promotions' />
    )
  }

  // Must leave empty h1 there for element below not to be cropped...
  return (
    <div className='index sales-promotions'>
      {/* eslint-disable-next-line */}
      <h1 />
      <cl-comments
        membershipid={membershipId}
        mountpath={`/operators/${operatorId}/memberships`}
        apihost={`https://memberships.${env()}.credlock.net`}
        operatorid={operatorId}
        token={token}
      />
    </div>
  )
}

export default Comments
